import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import { ContractorPackageLineItem } from "@interfaces/contractorPackage";

interface PackageDetailsProps {
  contractorPackage: ContractorPackageLineItem;
}
export const PackageDetails = ({ contractorPackage }: PackageDetailsProps) => {
  return (
    <Table size="small" aria-label="purchases">
      <TableBody>
        <TableRow key="1">
          <TableCell>Business Name</TableCell>
          <TableCell>{contractorPackage.contractorName}</TableCell>
          <TableCell align="right"></TableCell>
          <TableCell align="right"></TableCell>
        </TableRow>
        <TableRow key="2">
          <TableCell>Value</TableCell>
          <TableCell>{contractorPackage.totalPackageValue}</TableCell>
          <TableCell align="right"></TableCell>
          <TableCell align="right"></TableCell>
        </TableRow>
        <TableRow key="3">
          <TableCell>Required Spend</TableCell>
          <TableCell>{contractorPackage.requiredSpend}</TableCell>
          <TableCell align="right"></TableCell>
          <TableCell align="right"></TableCell>
        </TableRow>
        <TableRow key="3">
          <TableCell>Required Hours</TableCell>
          <TableCell>{contractorPackage.requiredHours}</TableCell>
          <TableCell align="right"></TableCell>
          <TableCell align="right"></TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
